jQuery(function($){

class Sc_Field_Editor_Typeahead {

	constructor() {
		this.settings = {};
		this.results = {};

		this.formSelector = '.sc-field-editor, .block-editor, .sc-field-editor-frontend';
		this.fieldWrapperSelector = '.field.typeahead';
		this.inputSelector = '.typeahead-input';
		this.valueSelector = '.typeahead-value';

		this.settings = {};
		this.results = {};

		this.typeaheadTimer;

		this.lastFieldName = false;

		let obj = this;

		//-------------------------
		// Initialize
		//-------------------------
		if($(this.formSelector).find(this.fieldWrapperSelector).length > 0) {
			getAllTypeaheadFieldOptions();
		}

		function getAllTypeaheadFieldOptions() {
			$(obj.formSelector).find(obj.fieldWrapperSelector).each(function(){
				let fieldName = obj.getFieldName($(this));
				console.log(fieldName);

				obj['settings'][fieldName] = JSON.parse(atob(obj.getFieldSettings($(this))));
				obj['results'][fieldName] = JSON.parse(atob(obj.getFieldResults($(this))));
				console.log(obj['settings'][fieldName]);
				console.log(obj['results'][fieldName]);

				obj.updateValues($(this), $(this), fieldName, obj.settings[fieldName], false);
			});			
		}


		//-------------------------
		// Search Results
		//-------------------------
		$(this.formSelector).on('keydown', this.inputSelector, function(e) {
			if(!$(this)[0].hasAttribute('react-typeahead-input')) {
				if(e.key == 'ArrowDown') {
					highlightTypeaheadResult($(this), 'next');
				} else if(e.key == 'ArrowUp') {
					highlightTypeaheadResult($(this), 'prev');
				} else if(e.key == 'Enter') {
					e.preventDefault();
					let formDiv = $(this).closest('.sc-field-editor');
					let fieldDiv = $(this).closest('.field.typeahead');
					let parentDiv = $(this).closest('.input-wrapper');
					let resultsDiv = parentDiv.find('.results');
					let results = $(resultsDiv[0]).find('.result');

					let highlightedIndex = getHighlightedResult(results);
					console.log(highlightedIndex);

					if(fieldDiv.hasClass('user-member-email') && parseInt(highlightedIndex) < 0) {
						console.log('Nothing highlighted, submitting');
						const submitButton = formDiv.find('button[admin-ajax-action]');
						if(submitButton.length) {
							submitButton.first().click();
						}
					}

					selectResult($(results[highlightedIndex]));
					obj.clearResults(parentDiv.find('.settings'));
				} else {
					obj.searchResults($(this));
				}
			}
		});

		$(this.formSelector).on('focus', this.inputSelector, function() {
			obj.searchResults($(this));
		});


		//-------------------------
		// Select Result
		//-------------------------
		$(this.formSelector).on('click', this.fieldWrapperSelector + ' .results .result', function() {
			selectResult($(this));
		});

		function selectResult(result) {
			const parentDiv = result.closest(obj.fieldWrapperSelector);
			const altTrigger = parentDiv.attr('alt_trigger');
			if(altTrigger) {
				parentDiv.trigger(altTrigger, [{result: result}]);
			} else {
				const fieldName = obj.getFieldName(parentDiv);
				const settings = obj.settings[fieldName];

				obj.updateValues(result, parentDiv, fieldName, settings, true);
			}
		}


		//-------------------------
		// Clear typeahead results
		//-------------------------
		$(document).on('click', function(e) {
			let parentField = $(e.target).closest('.field');
			let inputWrapper = parentField.find('.input-wrapper');
			if(inputWrapper.length == 0 || !inputWrapper.hasClass(obj.lastFieldName)) {
				$(obj.formSelector).find(obj.fieldWrapperSelector).each(function(){
					obj.clearResults($(this).find('.settings'));
				});
				obj.lastFieldName = false;
			}
		});


		//-------------------------
		// Clear selected results
		//-------------------------
		$(this.formSelector).on('click', '.close, .results-empty .clear', function() {
		// $(this.formSelector).on('click', this.fieldWrapperSelector + ' .selected .result .close', function() {
			let parentDiv = $(this).closest(obj.fieldWrapperSelector);
			let fieldName = obj.getFieldName(parentDiv);
			let settings = obj.settings[fieldName];

			let selectedResult = $(this).closest('.result');
			let postId = selectedResult.attr('post_id');

			//Remove result div
			selectedResult.remove();
			console.log(postId);

			//Show input if single
			if(settings.multiple == false) {
				let isRequired = parentDiv.find('> .labels .required').length > 0;
				let valueInput = parentDiv.find(obj.valueSelector);
				let textInput = parentDiv.find(obj.inputSelector);

				console.log('isRequired', isRequired);

				textInput.show();
				if(isRequired) valueInput.attr('required', true);
			}

			//Remove error message if present
			if(parentDiv.find('.results-empty').length) parentDiv.find('.results-empty').remove();

			//Write updated value to hidden input
			let currentValues = parentDiv.find(obj.valueSelector).val();
			if(currentValues == '' || settings.multiple == false) currentValues = '[]';
			currentValues = JSON.parse(currentValues);

			let newValues = [];
			$.each(currentValues, function(i, result){
				if(result != postId) newValues.push(result);
			});
			parentDiv.find(obj.valueSelector).val(JSON.stringify(newValues)).trigger('change');

			let addNewButton = parentDiv.find('.add-new');
			if(addNewButton.length > 0) parentDiv.find('.add-new').show();
		});


		//-------------------------
		// Up/Down Keys
		//-------------------------
		function getHighlightedResult(results) {
			let className = 'highlighted';

			let highlightedIndex = -1;
			for(var i = results.length - 1; i >= 0; i--) {
				if($(results[i]).hasClass(className)) {
					highlightedIndex = i;
					break;
				}
			}

			return highlightedIndex;
		}

		function highlightTypeaheadResult(field, direction) {
			let parentDiv = field.closest('.input-wrapper');
			let resultsDiv = parentDiv.find('.results');
			let results = $(resultsDiv[0]).find('.result');
			let className = 'highlighted';

			let highlightedIndex = getHighlightedResult(results);

			let newIndex;
			if(highlightedIndex == -1) {
				newIndex = direction == 'next' ? 0 : results.length - 1;
			} else {
				newIndex = direction == 'next' ? highlightedIndex + 1 : highlightedIndex - 1;
				if(newIndex == -1) newIndex = results.length - 1;
				if(newIndex == results.length) newIndex = 0;
			}

			$.each(results, function(){
				$(this).removeClass(className);
			});

			$(results[newIndex]).addClass(className);

			ensureInView(resultsDiv[0], results[newIndex]);
		}

		function ensureInView(container, element) {
		    //Determine container top and bottom
		    let cTop = container.scrollTop;
		    let cBottom = cTop + container.clientHeight;

		    //Determine element top and bottom
		    let eTop = element.offsetTop;
		    let eBottom = eTop + element.clientHeight;

		    //Check if out of view
		    if (eTop < cTop) {
		      container.scrollTop -= (cTop - eTop);
		    }
		    else if (eBottom > cBottom) {
		      container.scrollTop += (eBottom - cBottom);
		    }
		}


		//-------------------------
		// Add New
		//-------------------------
		$(this.formSelector).find('.add-new').each(function(){
			setRequired($(this), false);
		});

		$(this.formSelector).on('click', this.fieldWrapperSelector + ' .add-new .select-popup-button', function() {
			const parentDiv = $(this).closest('.add-new');
			const parentDivWrapper = parentDiv.closest('.add-new-wrapper');

			if(!$(this).hasClass('create-new')) {
				const addNewFields = JSON.parse(atob(parentDiv.attr('add_new_fields')));
				
				console.log(addNewFields);
				$.each(addNewFields, function(newField, existingField){
					let existingValue;
					console.log($('[name="sc-fields[' + existingField + ']"]').length, $('[name="sc-fields[' + existingField + ']"]'));
					if($('[name="sc-fields[' + existingField + ']"]').length) {
						existingValue = $('[name="sc-fields[' + existingField + ']"]').val();
						console.log(existingValue, parentDiv.find('[name="new_' + newField + '"]'));
						parentDiv.find('[name="sc-fields[new_' + newField + ']"]').each(function(){
							$(this).val(existingValue);
						});
					}
				});
			}

			parentDiv.find('.add-new-fields').addClass('visible');
			parentDivWrapper.find('.new-fields-bg').show();
		});

		$(this.formSelector).on('click', this.fieldWrapperSelector + ' .add-new-wrapper .new-fields-bg', function() {
			const parentDivWrapper = $(this).closest('.add-new-wrapper');
			parentDivWrapper.find('.add-new-fields').removeClass('visible');
			parentDivWrapper.find('.new-fields-bg').hide();
		});

		$(this.formSelector).on('click', this.fieldWrapperSelector + ' .add-new .add-new-fields .create-new', function(e) {
			e.stopPropagation();
			let parentDiv = $(this).closest(obj.fieldWrapperSelector);

			let el = $(this);

			createNewFromTypeahead(el, parentDiv);
		});

		$(this.formSelector).on('keydown', this.fieldWrapperSelector + ' .add-new .add-new-fields input', function(e) {
			if(e.keyCode == 13) { //Enter
				e.preventDefault();
				const parentDiv = $(this).closest('.add-new-fields');
				parentDiv.find('.create-new').trigger('click');
			}
		});

		function createNewFromTypeahead(el, parentDiv) {
			setTimeout(function(){
				let parentField = el.closest('.field.typeahead');
				console.log(parentField.find('.create-new--invalid'));
				if(parentField.find('.create-new--invalid').length) return;

				let parentFieldName = parentField.attr('field_name');
				let parentFieldInput = parentDiv.find('[name="' + parentField.attr('full_field_name') + '"]');

				let fields = {};
				el.closest('.add-new-fields').find('[name]').each(function(){
					let fieldName = $(this).closest('.field').attr('field_name');
					let fieldValue = $(this).val();
					if(fieldValue.length) fields[fieldName] = fieldValue;
				});

				console.log(fields);
				console.log(Object.keys(fields).length);

				if(!obj.results.hasOwnProperty(parentFieldName)) {
					getAllTypeaheadFieldOptions();
				}
				let settings = obj.settings[parentFieldName];

				let data = {
					action: 'sc_field_editor_ajax_add_new_typeahead_post',
					post_fields: fields,
					post_type: el.attr('post_type')
				};

				if(el[0].hasAttribute('typeahead_attributes')) {
					data.typeahead_attributes = el.attr('typeahead_attributes');
				}

				if(el[0].hasAttribute('typeahead_dynamic_attributes')) {
					const dynamicAttributeNames = JSON.parse(atob(el.attr('typeahead_dynamic_attributes')));

					let dynamicAttributes = {};
					if(dynamicAttributeNames.hasOwnProperty('global')) {
						$.each(dynamicAttributeNames.global, function(i, key){
							if(key == 'post_title') {
								dynamicAttributes[key] = encodeURI($('[name="' + key + '"]').val());
							} else {
								dynamicAttributes[key] = encodeURI($('[name="sc-fields[' + key + ']"]').val());
							}
						});
					}
					if(dynamicAttributeNames.hasOwnProperty('array')) {
						$.each(dynamicAttributeNames.array, function(i, key){
							const parentArrayFieldGroup = parentField.closest('.array-field-group');
							const fieldPrefix = parentArrayFieldGroup.attr('parent');
							const orderNumber = parentArrayFieldGroup.attr('order');
							const fullFieldName = 'sc-fields[' + fieldPrefix + '][' + orderNumber + '][' + key + ']';

							dynamicAttributes[key] = encodeURI(parentArrayFieldGroup.find('[name="' + fullFieldName + '"]').val());
						});
					}

					console.log(dynamicAttributes);

					data.typeahead_dynamic_attributes = btoa(JSON.stringify(dynamicAttributes));
				}

				el.after('Creating ' + el.attr('post_type') + '...').hide();

				console.log(data);

				if(!Object.keys(fields).length) return;

				$.post('/wp-admin/admin-ajax.php', data, function(response){
					console.log(response);
					let array = JSON.parse(atob(response));

					console.log(array);
					console.log(obj);
					if(array.hasOwnProperty('error')) {
						window.alert(array.error);
					} else {
						array[0].title = array[0].post_title;
						console.log(parentFieldName);
						console.log(array);

						$.each(obj.results[parentFieldName][0], function(key, value){
							if(!array[0].hasOwnProperty(key)) array[0][key] = '';
						});
						obj.results[parentFieldName].push(array[0]);

						let template = '<div class="title">{{post_title}}</div>';
						let emptyMessage = '';
						let selectedHtml = obj.getTemplateStringFromArray('selected', array, template, emptyMessage, el);

						let textInput = parentDiv.find(obj.inputSelector).attr('required', false);
						if(!settings.multiple) textInput.hide();

						let postIds = [];
						if(parentFieldInput.val().length) {
							let previousValues = JSON.parse(parentFieldInput.val());
							$.each(previousValues, function(index, value){
									postIds.push(value);
									counter++;
							});
						}
						postIds.push(array[0].post_id);
						console.log(postIds);

						parentDiv.find(obj.valueSelector).val(JSON.stringify(postIds)).trigger('change');

						obj.displaySelectedResults(parentDiv, parentFieldName, settings, postIds);

						parentDiv.find('.add-new-fields').removeClass('visible');
						if(settings.multiple) {
							parentDiv.find('.add-new-fields input, .add-new-fields textarea, .add-new-fields select').each(function(){
								$(this).val('').attr('required', false);
							});
						}
						parentDiv.find('.new-fields-bg').hide();
					}
				});
			}, 100);			
		}
	}


	//=========================
	// Get field info 
	//=========================
	getFieldName(el) {
		return el.find('.settings').attr('fieldName');
	}

	getFieldSettings(el) {
		return el.find('.settings').attr('settings');
	}

	getFieldResults(el) {
		return el.find('.results').attr('results');
	}


	//=========================
	// Update Values 
	//=========================
	updateValues(el, parentDiv, fieldName, settings, update) {
		//Write to hidden input
		let values = this.updateValuesArray(el, parentDiv, fieldName, settings, update);
		parentDiv.find(this.valueSelector).val(JSON.stringify(values)).trigger('change');

		//Clear input
		parentDiv.find(this.inputSelector).val('');
		if(settings.multiple == false && values.length > 0) {
			let isRequired = parentDiv.find('label .required').length > 0;
			let textInput = parentDiv.find(this.inputSelector);

			textInput.hide();
			// if(isRequired) textInput.attr('required', false);
		}

		//Display selected results
		this.displaySelectedResults(parentDiv, fieldName, settings, values);
	}

	updateValuesArray(el, parentDiv, fieldName, settings, update) {
		let values = parentDiv.find(this.valueSelector).val();

		if(values == '') values = '[]';
		values = JSON.parse(values);
		if(update === true) values.push(el.attr('post_id'));
		return values;
	}

	displaySelectedResults(parentDiv, fieldName, settings, values) {
		let results = this.results[fieldName];
		let selectedResults = [];
		$.each(values, function(i, id) {
			$.each(results, function(j, result){
				if(result.post_id == id) selectedResults.push(result);
			});
		});
		console.log(fieldName, selectedResults);
		if(!settings.hasOwnProperty('selected_template') && settings.hasOwnProperty('result_template')) {
			settings.selected_template = settings.result_template;
		}
		let selectedHtml = this.getTemplateStringFromArray('selected', selectedResults, settings.selected_template, '', parentDiv);
		parentDiv.find('.selected').html(selectedHtml);

		if(settings.multiple != true && selectedHtml != '') {
			let addNewButton = parentDiv.find('.add-new');
			if(addNewButton.length > 0) parentDiv.find('.add-new').hide();
		}
	}


	//=========================
	// Search Results 
	//=========================
	searchResults(el) {
		let parentDiv = el.closest(this.fieldWrapperSelector)
		let fieldName = parentDiv.find('.settings').attr('fieldname');
		let results = parentDiv.find('.results');

		let obj = this;

		clearTimeout(this.typeaheadTimer);
		this.typeaheadTimer = setTimeout(function() {
			if(!results.closest('.input-wrapper').hasClass('for-block')) {
				let resultString = obj.searchResultsArray(el.val(), fieldName, parentDiv);
				results.html(resultString);
			}
			results.addClass('has-results');
		}, 250);

		//Populate previous target and fieldName
		obj.lastFieldName = obj.getFieldName($(el));
	}

	hideSearchResults(el) {
		let parentDiv = el.closest(this.fieldWrapperSelector)
		let results = parentDiv.find('.results');

		clearTimeout(this.typeaheadTimer);
		this.typeaheadTimer = setTimeout(function() {
			results.removeClass('has-results');
		}, 250);
	}

	searchResultsArray(query, fieldName, parentDiv) {
		if(this.results[fieldName] == undefined || parentDiv.hasClass('use-field-results')) this.results[fieldName] = JSON.parse(atob(parentDiv.find('.results').attr('results')));
		if(this.settings[fieldName] == undefined || parentDiv.hasClass('use-field-settings')) this.settings[fieldName] = JSON.parse(atob(parentDiv.find('.settings').attr('settings')));

		let allResults = this.results[fieldName];
		let settings = this.settings[fieldName];

		let currentVal = parentDiv.find(this.valueSelector).val();
		let selectedResults = currentVal != '' ? JSON.parse(currentVal) : [];

		//Convert values to int
		$.each(selectedResults, function(i, item){
			selectedResults[i] = parseInt(item);
		});

		//Search for matches
		let results = [];
		$.each(allResults, function(i, item){
			let valid = false;
			if(!selectedResults.includes(item.post_id)) {
				$.each(settings.search_fields, function(j, field){
					if(parentDiv.hasClass('timepicker')) {
						if(item[field].toString().toLowerCase().startsWith(query.toLowerCase())) valid = true;
					} else {
						if(~item[field].toString().toLowerCase().indexOf(query.toLowerCase())) valid = true;
					}
				});
			}

			if(valid === true) results.push(item);
		});

		let emptyMessage = '<div class="result no-matches">No matches for your search "' + query + '"</div><!-- .result -->';
		return this.getTemplateStringFromArray('results', results, settings.result_template, emptyMessage, parentDiv, query);
	}

	clearResults(el) {
		el.closest(this.fieldWrapperSelector).find('.results').removeClass('has-results');
	}


	//=========================
	// Result Processing 
	//=========================
	getTemplateStringFromArray(type, array, template, emptyMessage, el, query = '') {
		if(array.length <= 0) return emptyMessage;

		console.log(query, query.length);

		const parentDiv = el.closest('.field');
		const deleteSvgDiv = parentDiv.find('.delete-svg');

		let deleteSvgMarkup;
		deleteSvgDiv.each(function(){
			deleteSvgMarkup = $(this).html();
		});

		//Find fields in template
		let templateFields = this.getFieldsFromTemplate(template);

		//Build result string
		let html = '';

		console.log(type);
		console.log(array);
		console.log(template);

		array = array.slice(0, 300);
		$.each(array, function(i, result){
			const classes = i == 0 && query.length ? 'result highlighted' : 'result';

			let resultString = '<div class="' + classes + '" post_id="' + result.post_id + '">';
			resultString += template;
			$.each(templateFields, function(j, field){
				let value = result[field];
				if(value === undefined) value = '';
				let re = new RegExp('{{' + field + '}}', "g");
				console.log(re, value);
				resultString = resultString.replace(re, result[field]);
			});
			if(type === 'selected') {
				if(result.edit_link !== undefined) resultString += '<div class="edit-link"><a href="' + result.edit_link + '" target="_blank">Edit &raquo;</a></div>';
				resultString += '<div class="close">' + deleteSvgMarkup + '</div>';
			}
			resultString += '</div><!-- .result -->';
			html += resultString;
		});

		return html;
	}

	getFieldsFromTemplate(str) {
		let templateFields = [],
			rxp = /{{([^}}]+)}/g,
			match;

		while(match = rxp.exec(str)) {
			if(!templateFields.includes(match[1])) templateFields.push(match[1]);
		}

		return templateFields;
	}

}

let scTypeahead = new Sc_Field_Editor_Typeahead();

});